
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1hgMC", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $eSUdr = parcelRequire("eSUdr");


var $1KmJq = parcelRequire("1KmJq");


var $eXmBZ = parcelRequire("eXmBZ");


var $inPa6 = parcelRequire("inPa6");


var $7aRa9 = parcelRequire("7aRa9");


var $euL71 = parcelRequire("euL71");


var $dPJCf = parcelRequire("dPJCf");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $bQm3c = parcelRequire("bQm3c");


var $dmDX7 = parcelRequire("dmDX7");

/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $6d27bc1ba96adced$export$64ed4f32859160d1 = /*#__PURE__*/ function(AccessType) {
    AccessType["EDIT"] = "EDIT";
    AccessType["VIEW"] = "VIEW";
    return AccessType;
}({});











var $a3fRD = parcelRequire("a3fRD");


var $3sFtD = parcelRequire("3sFtD");

const $74dcdc5559d29390$var$i18n = (0, $cgtv4.defineMessages)({
    successTitle: {
        id: "grant-access-dialog.request-access-popup.success-flag-title",
        defaultMessage: "Request sent"
    },
    successContent: {
        id: "grant-access-dialog.request-access-popup.success-flag-content",
        defaultMessage: "We\u2019ve asked the content owner to give you edit access. You\u2019ll get an email once the request is approved."
    },
    errorTitle: {
        id: "grant-access-dialog.request-access-popup.error-flag-title",
        defaultMessage: "We couldn\u2019t send your request"
    },
    errorContent: {
        id: "grant-access-dialog.request-access-popup.error-flag-content",
        defaultMessage: "We ran into a problem processing your request. Refresh and try again."
    },
    successIconLabel: {
        id: "grant-access-dialog.request-access-popup.success-icon-label",
        defaultMessage: "Success"
    },
    errorIconLabel: {
        id: "grant-access-dialog.request-access-popup.error-icon-label",
        defaultMessage: "Error"
    }
});
const $74dcdc5559d29390$export$debd49be6c80c49e = (flagHandler)=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const showSuccessFlag = ()=>flagHandler.showSuccessFlag({
            id: `request-access-success-${Date.now()}`,
            title: formatMessage($74dcdc5559d29390$var$i18n.successTitle),
            description: formatMessage($74dcdc5559d29390$var$i18n.successContent),
            customIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                label: formatMessage($74dcdc5559d29390$var$i18n.successIconLabel),
                color: "var(--ds-icon-success, #6A9A23)",
                spacing: "spacious"
            }),
            isAutoDismiss: true
        });
    const showErrorFlag = ()=>flagHandler.showErrorFlag({
            id: `request-access-error-${Date.now()}`,
            title: formatMessage($74dcdc5559d29390$var$i18n.errorTitle),
            description: formatMessage($74dcdc5559d29390$var$i18n.errorContent),
            customIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                label: formatMessage($74dcdc5559d29390$var$i18n.errorIconLabel),
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "spacious"
            }),
            isAutoDismiss: true
        });
    return {
        showSuccessFlag: showSuccessFlag,
        showErrorFlag: showErrorFlag
    };
};









var $xQxzY = parcelRequire("xQxzY");







const $3a3b3829438f4478$var$useUserPageAccessTypeContentOperationsQuery = (0, $eSUdr.default)`query useUserPageAccessTypeContentOperationsQuery($id:ID!){singleContent(id:$id){id type operations{operation targetType}}}`;
const $3a3b3829438f4478$export$577e938c860c1afa = (contentId)=>{
    const { data: data, loading: loading, error: error } = (0, $xQxzY.useQuery)($3a3b3829438f4478$var$useUserPageAccessTypeContentOperationsQuery, {
        variables: {
            id: contentId
        }
    });
    (0, $42omo.useEffect)(()=>{
        if (error) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
        });
    }, [
        error
    ]);
    const accessTypes = (0, $42omo.useMemo)(()=>{
        const contentNode = data?.singleContent;
        const operations = contentNode?.operations ?? [];
        const contentType = contentNode?.type ?? undefined;
        const result = [];
        // Check if the user has the view permission
        if (operations.find((op)=>op?.operation === 'read' && op.targetType === contentType)) result.push('VIEW');
        // Check if the user has the edit permission
        if (operations.find((op)=>op?.operation === 'update' && op.targetType === contentType)) result.push('EDIT');
        return result;
    }, [
        data
    ]);
    return {
        accessTypes: accessTypes,
        error: error,
        loading: loading
    };
};


const $4542b58e124be250$var$i18n = (0, $cgtv4.defineMessages)({
    title: {
        id: "grant-access-dialog.request-access-popup.flag-title",
        defaultMessage: "Ask to edit this content?"
    },
    content: {
        id: "grant-access-dialog.request-access-popup.flag-content",
        defaultMessage: "You\u2019ll get an email when your request is approved."
    },
    requestBtn: {
        id: "grant-access-dialog.request-access-popup.approve-btn",
        defaultMessage: "Ask to edit"
    }
});
// Only allowed value is the string `true`
const $4542b58e124be250$var$QUERY_PARAM_NAME = 'redirectedFromRestrict';
const $4542b58e124be250$var$useQueryParamRedirectedFromRestrict = (0, $dPJCf.createSingleQueryParamHook)($4542b58e124be250$var$QUERY_PARAM_NAME);
// Flag id
const $4542b58e124be250$var$FLAG_ID = 'request-edit-access';
// GraphQL endpoints - not reusable due to eslint rule
const $4542b58e124be250$var$RequestAccessPopupRequestAccessMutation = (0, $eSUdr.default)`mutation RequestAccessPopupRequestAccessMutation($accessType:AccessType!$pageId:String!){requestPageAccess(requestPageAccessInput:{accessType:$accessType pageId:$pageId}){displayName}}`;
const $4542b58e124be250$export$a1b413940dee8e5e = (contentId, flags)=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isRedirectedFromRestrict = $4542b58e124be250$var$useQueryParamRedirectedFromRestrict();
    const { isLoadingForFirstTime: isLoadingForFirstTime, pendingRequestExists: pendingRequestExists } = (0, $dmDX7.usePendingRequestExists)({
        contentId: contentId
    });
    const shouldSkip = Boolean(// No SSR
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    // Not available in Free edition
    edition === (0, $euL71.ConfluenceEdition).FREE || // No particular query param
    !isRedirectedFromRestrict || // Query to check if user has a pending access request is still loading
    isLoadingForFirstTime || // If a pending request exists, show no flag
    pendingRequestExists);
    const { showSuccessFlag: showSuccessFlag, showErrorFlag: showErrorFlag } = (0, $74dcdc5559d29390$export$debd49be6c80c49e)(flags);
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { accessTypes: accessTypes, error: contentPermissionError } = (0, $3a3b3829438f4478$export$577e938c860c1afa)(contentId);
    const [requestAccessMutation, { error: requestAccessError }] = (0, $1KmJq.useMutation)($4542b58e124be250$var$RequestAccessPopupRequestAccessMutation, {
        onCompleted: ()=>{
            showSuccessFlag();
        },
        onError: ()=>{
            showErrorFlag();
        }
    });
    const reportPopupEvent = (0, $42omo.useCallback)((analyticEvtType)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: analyticEvtType === 'request' ? 'requestEditAction' : 'dismissRequestEditPopupAction',
                source: 'requestAccessPopup',
                attributes: {
                    contentId: contentId,
                    accessTypes: accessTypes.join(',')
                }
            }
        }).fire();
        // Decision has been made. No more popups needed.
        setQueryParams({
            [$4542b58e124be250$var$QUERY_PARAM_NAME]: undefined
        });
    }, [
        setQueryParams,
        contentId,
        createAnalyticsEvent,
        accessTypes
    ]);
    const requestAccess = (0, $42omo.useCallback)(()=>{
        // Dismiss the popup first (unblocking the UI)
        flags.hideFlag($4542b58e124be250$var$FLAG_ID);
        reportPopupEvent('request');
        // Send the request
        return requestAccessMutation({
            variables: {
                accessType: (0, $6d27bc1ba96adced$export$64ed4f32859160d1).EDIT,
                pageId: contentId
            }
        });
    }, [
        contentId,
        reportPopupEvent,
        requestAccessMutation,
        flags
    ]);
    // Error handling
    (0, $42omo.useEffect)(()=>{
        if (shouldSkip) return;
        if (contentPermissionError) (0, $5ZqQS.getMonitoringClient)().submitError(contentPermissionError, {
            attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
        });
        if (requestAccessError) {
            (0, $5ZqQS.getMonitoringClient)().submitError(requestAccessError, {
                attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
            });
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'errored',
                    actionSubject: 'requestEditSent',
                    source: 'requestEditPopup',
                    attributes: {
                        contentId: contentId,
                        accessTypes: accessTypes.join(',')
                    }
                }
            }).fire();
        }
    }, [
        accessTypes,
        contentPermissionError,
        requestAccessError,
        shouldSkip,
        createAnalyticsEvent,
        contentId
    ]);
    // When the component loads
    (0, $42omo.useEffect)(()=>{
        if (shouldSkip) return;
        if (accessTypes && accessTypes.includes('VIEW') && !accessTypes.includes('EDIT')) {
            // Display the flag
            flags.showFlag({
                id: $4542b58e124be250$var$FLAG_ID,
                title: formatMessage($4542b58e124be250$var$i18n.title),
                customIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                    color: "var(--ds-text-information, #1558BC)",
                    label: formatMessage($4542b58e124be250$var$i18n.title),
                    spacing: "spacious"
                }),
                description: formatMessage($4542b58e124be250$var$i18n.content),
                actions: [
                    {
                        content: formatMessage($4542b58e124be250$var$i18n.requestBtn),
                        onClick: requestAccess
                    }
                ],
                onClose: ()=>reportPopupEvent('dismiss')
            });
            // Event
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'viewed',
                    actionSubject: 'flag',
                    actionSubjectId: 'showRequestToEditPopup',
                    source: 'requestAccessPopup',
                    attributes: {
                        contentId: contentId,
                        accessTypes: accessTypes.join(',')
                    }
                }
            }).fire();
        }
    }, [
        reportPopupEvent,
        requestAccess,
        flags,
        formatMessage,
        accessTypes,
        shouldSkip,
        contentId,
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            flags.hideFlag($4542b58e124be250$var$FLAG_ID);
        };
    }, [
        flags
    ]);
};
// Currently there's a mix use of Atlaskit flags and Confluence flags.
// This component is using Confluence flags.
const $4542b58e124be250$var$RequestAccessPopupFlagWraper = ({ contentId: contentId, flags: flags })=>{
    $4542b58e124be250$export$a1b413940dee8e5e(contentId, flags);
    return null;
};
const $4542b58e124be250$export$8e100eba08cca59e = (0, $7aRa9.withFlags)($4542b58e124be250$var$RequestAccessPopupFlagWraper);
module.exports["useRequestAccessPopup"] = $4542b58e124be250$export$a1b413940dee8e5e;
module.exports["RequestAccessPopupComponent"] = $4542b58e124be250$export$8e100eba08cca59e;

});

parcelRegister("7aRa9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $42omo.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("dmDX7", function(module, exports) {
/** @graphql cc **/ 
var $42omo = parcelRequire("42omo");


var $eSUdr = parcelRequire("eSUdr");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");

const $4aa29e57813b75ee$var$UsePendingRequestExistsQuery = (0, $eSUdr.default)`query usePendingRequestExistsQuery($accessRequestedAaid:String!$cloudId:ID!$contentId:ID!){confluence_pendingRequestExists(accessRequestedAaid:$accessRequestedAaid cloudId:$cloudId contentId:$contentId){isPendingAccessRequestExists}}`;
const $4aa29e57813b75ee$export$5354a7f39c2c364a = ({ contentId: contentId })=>{
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = !userId || !cloudId || !contentId || !(0, $6mKj3.expValEquals)('confluence_frontend_existing_access_request_checks', 'cohort', 'experiment');
    const [isLoadingForFirstTime, setIsLoadingForFirstTime] = (0, $42omo.useState)(!shouldSkip);
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($4aa29e57813b75ee$var$UsePendingRequestExistsQuery, {
        variables: {
            cloudId: cloudId,
            accessRequestedAaid: userId ?? '',
            contentId: contentId ?? ''
        },
        skip: shouldSkip,
        fetchPolicy: 'network-only',
        onCompleted: ()=>{
            setIsLoadingForFirstTime(false);
        }
    });
    const pendingRequestExists = Boolean(data?.confluence_pendingRequestExists?.isPendingAccessRequestExists);
    return {
        pendingRequestExists: pendingRequestExists,
        loading: loading,
        error: error,
        isLoadingForFirstTime: isLoadingForFirstTime
    };
};
module.exports["usePendingRequestExists"] = $4aa29e57813b75ee$export$5354a7f39c2c364a;

});

parcelRegister("3aGPB", function(module, exports) {
/* GrantAccessDialog.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $gmMgo = parcelRequire("gmMgo");


var $T1bCI = parcelRequire("T1bCI");


var $eSUdr = parcelRequire("eSUdr");


var $1DWH0 = parcelRequire("1DWH0");


var $cO1el = parcelRequire("cO1el");


var $eEA8O = parcelRequire("eEA8O");


var $30qWc = parcelRequire("30qWc");


var $9wGTI = parcelRequire("9wGTI");


var $gqqjz = parcelRequire("gqqjz");


var $jJK3p = parcelRequire("jJK3p");


var $fs6LW = parcelRequire("fs6LW");


var $lsxnT = parcelRequire("lsxnT");

/**
 * @generated SignedSource<<f70cb19064aace212d3396de9f42cec6>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: cc
 *
 * @see https://go/typsy
 **/ var $1c9beeba0e68a72c$export$64ed4f32859160d1 = /*#__PURE__*/ function(AccessType) {
    AccessType["EDIT"] = "EDIT";
    AccessType["VIEW"] = "VIEW";
    return AccessType;
}({});


const $118c9dec782673ef$var$GrantAccessDialogGrantContentAccessMutation = (0, $eSUdr.default)`mutation GrantAccessDialogGrantContentAccessMutation($grantContentAccessInput:GrantContentAccessInput!){grantContentAccess(grantContentAccessInput:$grantContentAccessInput){success}}`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $118c9dec782673ef$var$DialogContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt44ar7 _1bsbkbql",
            __cmplp.className
        ])
    });
});
const $118c9dec782673ef$var$MessageContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8fhey _zulp1b66 _19pkutpp _otyrpxbi _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
$118c9dec782673ef$var$MessageContainer.displayName = 'MessageContainer';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $118c9dec782673ef$var$ActionsContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8fhey _1e0c1txw _1bahh9n0",
            __cmplp.className
        ])
    });
});
const $118c9dec782673ef$var$DialogAnchor = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $118c9dec782673ef$var$i18n = (0, $cgtv4.defineMessages)({
    dialogTitleViewRequest: {
        id: "grant-access-dialog.dialog.title.view",
        defaultMessage: "View access request"
    },
    dialogTitleEditRequest: {
        id: "grant-access-dialog.dialog.title.edit",
        defaultMessage: "Edit access request"
    },
    grantViewAccess: {
        id: "grant-access-dialog.dialog.action.grant.view",
        defaultMessage: "Grant view access"
    },
    grantEditAccess: {
        id: "grant-access-dialog.dialog.action.grant.edit",
        defaultMessage: "Grant edit access"
    },
    denyAccess: {
        id: "grant-access-dialog.dialog.action.deny",
        defaultMessage: "Deny"
    },
    successTitle: {
        id: "grant-access-dialog.success.title",
        defaultMessage: "Access request granted"
    },
    errorTitle: {
        id: "grant-access-dialog.error.title",
        defaultMessage: "Access request error"
    },
    //412
    noMailServer: {
        id: "grant-access-dialog.error.no-mail-server",
        defaultMessage: "Access was granted, but there is not a mail server configured so the notification could not be sent."
    },
    //502
    sendEmailError: {
        id: "grant-access-dialog.error.send-email",
        defaultMessage: "Access was granted, but an unexpected error happened while sending the notification."
    },
    //every other error
    genericError: {
        id: "grant-access-dialog.error.generic",
        defaultMessage: "Sorry, there was an unexpected error while granting access."
    },
    //202
    alreadyGranted: {
        id: "grant-access-dialog.success.already-granted",
        defaultMessage: "Access was already granted to the user."
    },
    //other success
    genericSuccess: {
        id: "grant-access-dialog.success.generic",
        defaultMessage: "Access was granted, a notification to the user will be sent."
    },
    requestedViewAccess: {
        id: "grant-access-dialog.dialog.message.request.view.access.to.content",
        defaultMessage: "{person} requested view access to <b>{contentTitle}</b>."
    },
    requestedEditAccess: {
        id: "grant-access-dialog.dialog.message.request.edit.access.to.content",
        defaultMessage: "{person} requested edit access to <b>{contentTitle}</b>."
    }
});
const $118c9dec782673ef$var$GrantAccessDialogComponent = ({ accessType: accessType = 'view', isOpen: isOpen = false, onActionClick: onActionClick = ()=>{}, accountId: accountId, contentId: contentId, createAnalyticsEvent: createAnalyticsEvent, intl: intl, displayName: displayName, children: children, contentTitle: contentTitle, profilePhoto: profilePhoto })=>{
    const { Popup: Popup } = (0, $lsxnT.useChoreographerAssets)();
    const generateAnalyticsProps = (0, $42omo.useCallback)(()=>({
            source: 'grantAccessDialog',
            attributes: {
                accessType: accessType
            }
        }), [
        accessType
    ]);
    (0, $42omo.useEffect)(()=>{
        if (createAnalyticsEvent) {
            const { attributes: attributes, source: source } = generateAnalyticsProps();
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'grantAccessScreen',
                    source: source,
                    attributes: {
                        ...attributes,
                        type: 'dialog'
                    }
                }
            }).fire();
        }
    }, [
        createAnalyticsEvent,
        generateAnalyticsProps
    ]);
    const generateGrantClickHandler = (0, $42omo.useCallback)((mutateGrantAccess)=>{
        const { attributes: attributes, source: source } = generateAnalyticsProps();
        return ()=>{
            createAnalyticsEvent && createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'grantAccess',
                    source: source,
                    attributes: attributes
                }
            }).fire();
            mutateGrantAccess({
                variables: {
                    grantContentAccessInput: {
                        contentId: contentId,
                        accessType: accessType === 'edit' ? (0, $1c9beeba0e68a72c$export$64ed4f32859160d1).EDIT : (0, $1c9beeba0e68a72c$export$64ed4f32859160d1).VIEW,
                        accountIdOrUsername: accountId
                    }
                }
            });
            if (onActionClick) onActionClick();
        };
    }, [
        accessType,
        accountId,
        onActionClick,
        contentId,
        createAnalyticsEvent,
        generateAnalyticsProps
    ]);
    const generateGrantAccessErrorHandler = (0, $42omo.useCallback)((flagsContainer)=>{
        const { formatMessage: formatMessage } = intl;
        const { attributes: attributes, source: source } = generateAnalyticsProps();
        const title = formatMessage($118c9dec782673ef$var$i18n.errorTitle);
        return (error)=>{
            const errorStatus = error?.graphQLErrors?.[0]?.message;
            let description;
            if (errorStatus === '412') description = formatMessage($118c9dec782673ef$var$i18n.noMailServer);
            else if (errorStatus === '502') description = formatMessage($118c9dec782673ef$var$i18n.sendEmailError);
            else description = formatMessage($118c9dec782673ef$var$i18n.genericError);
            // It's not clear whether this codepath is actually used for expected errors,
            // as comments elsewhere note that the experimental resolver results in
            // responseStatus=null for error state, which is handled by the success path.
            // Analytics should help us determine how/whether the error handling here is valid.
            createAnalyticsEvent && createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'shown',
                    actionSubject: 'error',
                    actionSubjectId: 'grantAccess',
                    source: source,
                    attributes: {
                        ...attributes,
                        errorStatus: errorStatus
                    }
                }
            }).fire();
            flagsContainer.showErrorFlag({
                title: title,
                description: description
            });
        };
    }, [
        intl,
        createAnalyticsEvent,
        generateAnalyticsProps
    ]);
    const generateGrantAccessSuccessHandler = (0, $42omo.useCallback)((flagsContainer)=>{
        const { formatMessage: formatMessage } = intl;
        const { attributes: attributes, source: source } = generateAnalyticsProps();
        return (response)=>{
            const success = response?.grantContentAccess?.success;
            if (!success) {
                createAnalyticsEvent && createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'failed',
                        actionSubject: 'accessRequest',
                        actionSubjectId: 'grantAccess',
                        source: source,
                        attributes: attributes
                    }
                }).fire();
                // experimental resolver throwing new error will result in responseStatus = null
                flagsContainer.showErrorFlag({
                    title: formatMessage($118c9dec782673ef$var$i18n.errorTitle),
                    description: formatMessage($118c9dec782673ef$var$i18n.genericError)
                });
                return;
            }
            createAnalyticsEvent && createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'granted',
                    actionSubject: 'access',
                    actionSubjectId: 'grantAccess',
                    source: source,
                    attributes: attributes
                }
            }).fire();
            flagsContainer.showSuccessFlag({
                title: formatMessage($118c9dec782673ef$var$i18n.successTitle),
                description: formatMessage($118c9dec782673ef$var$i18n.genericSuccess)
            });
        };
    }, [
        intl,
        createAnalyticsEvent,
        generateAnalyticsProps
    ]);
    const generateDenyAccessHandler = (0, $42omo.useCallback)(()=>{
        const { attributes: attributes, source: source } = generateAnalyticsProps();
        return ()=>{
            createAnalyticsEvent && createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'denyAccess',
                    source: source,
                    attributes: attributes
                }
            }).fire();
            if (onActionClick) onActionClick();
        };
    }, [
        onActionClick,
        createAnalyticsEvent,
        generateAnalyticsProps
    ]);
    const getContent = (0, $42omo.useCallback)((flagsContainer)=>{
        const requestedAccessCopy = accessType === 'view' ? $118c9dec782673ef$var$i18n.requestedViewAccess : $118c9dec782673ef$var$i18n.requestedEditAccess;
        const dialogTitle = accessType === 'view' ? $118c9dec782673ef$var$i18n.dialogTitleViewRequest : $118c9dec782673ef$var$i18n.dialogTitleEditRequest;
        const grantAccessButtonText = accessType === 'view' ? $118c9dec782673ef$var$i18n.grantViewAccess : $118c9dec782673ef$var$i18n.grantEditAccess;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($118c9dec782673ef$var$DialogContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            size: "large",
            as: "h3"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), dialogTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($118c9dec782673ef$var$MessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fs6LW.ProfileAvatar), {
            userId: accountId,
            name: displayName,
            src: profilePhoto,
            size: "xsmall"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...requestedAccessCopy,
            values: {
                person: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jJK3p.ProfileLink), {
                    userId: accountId,
                    fullName: displayName
                }),
                contentTitle: contentTitle,
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($118c9dec782673ef$var$ActionsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "subtle-link",
            onClick: generateDenyAccessHandler(),
            testId: "deny-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $118c9dec782673ef$var$i18n.denyAccess)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $30qWc.MutationInterop), {
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ mutation: $118c9dec782673ef$var$GrantAccessDialogGrantContentAccessMutation,
            onError: generateGrantAccessErrorHandler(flagsContainer),
            onCompleted: generateGrantAccessSuccessHandler(flagsContainer)
        }, (mutateGrantAccess)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                onClick: generateGrantClickHandler(mutateGrantAccess),
                testId: "grant-button",
                appearance: "primary"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), grantAccessButtonText)))));
    }, [
        accessType,
        accountId,
        contentTitle,
        displayName,
        generateDenyAccessHandler,
        generateGrantAccessErrorHandler,
        generateGrantAccessSuccessHandler,
        generateGrantClickHandler,
        profilePhoto
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flagsContainer)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Popup, {
            isOpen: Boolean(isOpen),
            content: ()=>getContent(flagsContainer),
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($118c9dec782673ef$var$DialogAnchor, {
                    "data-test-id": "inline-dialog-anchor",
                    ...triggerProps
                }, children),
            shouldRenderToParent: (0, $9wGTI.fg)('should-render-to-parent-should-be-truepermissions')
        }));
};
const $118c9dec782673ef$export$6a13f73b981576d3 = (0, $1DWH0.default)()((0, $gmMgo.default)($118c9dec782673ef$var$GrantAccessDialogComponent));
module.exports["GrantAccessDialog"] = $118c9dec782673ef$export$6a13f73b981576d3;

});

parcelRegister("30qWc", function(module, exports) {

var $308Wd = parcelRequire("308Wd");

function $9acca7871dfd8a5c$export$a59d7e865b63a081({ children: children, mutation: mutation, ...props }) {
    const [mutate, result] = (0, $308Wd.useMutationInterop)(mutation, props);
    return children(mutate, result);
}
module.exports["MutationInterop"] = $9acca7871dfd8a5c$export$a59d7e865b63a081;

});

parcelRegister("jJK3p", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $jyPfN = parcelRequire("jyPfN");


var $cPER9 = parcelRequire("cPER9");


var $4qzKl = parcelRequire("4qzKl");


var $a6t12 = parcelRequire("a6t12");


var $5XsiK = parcelRequire("5XsiK");


var $dD7ks = parcelRequire("dD7ks");

const $5c1fbd48d7d200d4$var$linkStyles = (0, $ecnYn.xcss)({
    textDecoration: 'underline',
    display: 'inline-block',
    cursor: 'pointer'
});
const $5c1fbd48d7d200d4$var$i18n = (0, $cgtv4.defineMessages)({
    profileLinkName: {
        id: "profile.link.name",
        defaultMessage: "{fullName} profile"
    }
});
const $5c1fbd48d7d200d4$export$a2a4245643e0242b = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(23);
    const { userId: userId, fullName: fullName, isAnonymous: t1, onUserLinkClick: onUserLinkClick, referralSource: referralSource, className: className, style: style, behavior: t2, position: t3, offset: offset, ariaLabel: ariaLabel, isUnderlinedByDefault: t4 } = t0;
    const isAnonymous = t1 === undefined ? false : t1;
    const behavior = t2 === undefined ? "link" : t2;
    const position = t3 === undefined ? "bottom-start" : t3;
    const isUnderlinedByDefault = t4 === undefined ? true : t4;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const intl = (0, $8C5kA.default)();
    const t5 = userId ?? "";
    let t6;
    if ($[0] !== t5) {
        t6 = {
            type: "USER",
            payload: {
                userId: t5
            }
        };
        $[0] = t5;
        $[1] = t6;
    } else t6 = $[1];
    const { href: teamsAppPersonProfileUrl } = (0, $dD7ks.useNavigateToTeamsApp)(t6);
    let t7;
    if ($[2] !== ariaLabel || $[3] !== behavior || $[4] !== className || $[5] !== fullName || $[6] !== intl || $[7] !== isAnonymous || $[8] !== isUnderlinedByDefault || $[9] !== offset || $[10] !== onUserLinkClick || $[11] !== position || $[12] !== referralSource || $[13] !== style || $[14] !== teamsAppPersonProfileUrl || $[15] !== userId) {
        t7 = ()=>{
            if (behavior === "card") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
                isAnonymous: isAnonymous,
                userId: userId,
                position: position,
                offset: offset,
                ariaLabel: ariaLabel
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                style: style,
                xcss: $5c1fbd48d7d200d4$var$linkStyles
            }, fullName));
            else {
                const linkStyle = {
                    ...style,
                    ...isUnderlinedByDefault ? {
                        textDecoration: "underline"
                    } : {}
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cPER9.PeopleLink), {
                    target: "_blank",
                    onClick: onUserLinkClick,
                    href: (0, $5XsiK.isTeamsAppEnabled)() ? teamsAppPersonProfileUrl : (0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, referralSource),
                    className: className,
                    style: linkStyle,
                    "data-testid": "profile-link",
                    "aria-label": ariaLabel || intl.formatMessage($5c1fbd48d7d200d4$var$i18n.profileLinkName, {
                        fullName: fullName
                    })
                }, fullName);
            }
        };
        $[2] = ariaLabel;
        $[3] = behavior;
        $[4] = className;
        $[5] = fullName;
        $[6] = intl;
        $[7] = isAnonymous;
        $[8] = isUnderlinedByDefault;
        $[9] = offset;
        $[10] = onUserLinkClick;
        $[11] = position;
        $[12] = referralSource;
        $[13] = style;
        $[14] = teamsAppPersonProfileUrl;
        $[15] = userId;
        $[16] = t7;
    } else t7 = $[16];
    const renderNameComponent = t7;
    let t8;
    if ($[17] !== fullName || $[18] !== hasViewUserProfilePermission || $[19] !== isAnonymous || $[20] !== renderNameComponent || $[21] !== userId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isAnonymous || !userId || userId === "" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            id: "profile.anonymous.name",
            defaultMessage: "Anonymous"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, hasViewUserProfilePermission ? renderNameComponent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, fullName)));
        $[17] = fullName;
        $[18] = hasViewUserProfilePermission;
        $[19] = isAnonymous;
        $[20] = renderNameComponent;
        $[21] = userId;
        $[22] = t8;
    } else t8 = $[22];
    return t8;
} : ({ userId: userId, fullName: fullName, isAnonymous: isAnonymous = false, onUserLinkClick: onUserLinkClick, referralSource: referralSource, className: className, style: style, behavior: behavior = 'link', position: position = 'bottom-start', offset: offset, ariaLabel: ariaLabel, isUnderlinedByDefault: isUnderlinedByDefault = true })=>{
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const intl = (0, $8C5kA.default)();
    const { href: teamsAppPersonProfileUrl } = (0, $dD7ks.useNavigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId ?? ''
        }
    });
    const renderNameComponent = ()=>{
        if (behavior === 'card') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
            isAnonymous: isAnonymous,
            userId: userId,
            position: position,
            offset: offset,
            ariaLabel: ariaLabel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style,
            xcss: $5c1fbd48d7d200d4$var$linkStyles
        }, fullName));
        else {
            const linkStyle = {
                ...style,
                ...isUnderlinedByDefault ? {
                    textDecoration: 'underline'
                } : {}
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cPER9.PeopleLink), {
                target: "_blank",
                onClick: onUserLinkClick,
                href: (0, $5XsiK.isTeamsAppEnabled)() ? teamsAppPersonProfileUrl : (0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, referralSource),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: linkStyle,
                "data-testid": "profile-link",
                "aria-label": ariaLabel || intl.formatMessage($5c1fbd48d7d200d4$var$i18n.profileLinkName, {
                    fullName: fullName
                })
            }, fullName);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isAnonymous || !userId || userId === '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "profile.anonymous.name",
        defaultMessage: "Anonymous"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, hasViewUserProfilePermission ? renderNameComponent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, fullName)));
};
module.exports["ProfileLink"] = $5c1fbd48d7d200d4$export$a2a4245643e0242b;

});

parcelRegister("cPER9", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $8lYIw = parcelRequire("8lYIw");


var $jlIaF = parcelRequire("jlIaF");


var $5XsiK = parcelRequire("5XsiK");

const $6a5a2957e3d32f84$export$43aa0d4f5c176033 = (0, $3u0dr.isReactCompilerActiveV1)() ? (props)=>{
    const $ = (0, $frIzR.c)(8);
    let href;
    let otherProps;
    let to;
    if ($[0] !== props) {
        ({ href: href, to: to, ...otherProps } = props);
        $[0] = props;
        $[1] = href;
        $[2] = otherProps;
        $[3] = to;
    } else {
        href = $[1];
        otherProps = $[2];
        to = $[3];
    }
    const url = to || href;
    const path = url && url.indexOf("/") !== 0 ? `/${url}` : url;
    const destination = !path.startsWith((0, $jlIaF.CONTEXT_PATH)) ? `${0, $jlIaF.CONTEXT_PATH}${path}` : path;
    const t0 = (0, $5XsiK.isTeamsAppEnabled)() ? url : destination;
    let t1;
    if ($[4] !== otherProps || $[5] !== props || $[6] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8lYIw.Link), {
            ...props,
            href: t0,
            ...otherProps
        });
        $[4] = otherProps;
        $[5] = props;
        $[6] = t0;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
} : (props)=>{
    const { href: href, to: to, ...otherProps } = props;
    const url = to || href;
    const path = url && url.indexOf('/') !== 0 ? `/${url}` : url;
    const destination = !path.startsWith((0, $jlIaF.CONTEXT_PATH)) ? `${0, $jlIaF.CONTEXT_PATH}${path}` : path;
    // eslint-disable-next-line @atlassian/a11y/anchor-has-content -- See https://go/a11y-anchor-has-content for more details
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8lYIw.Link), {
        ...props,
        href: (0, $5XsiK.isTeamsAppEnabled)() ? url : destination,
        ...otherProps
    });
};
$6a5a2957e3d32f84$export$43aa0d4f5c176033.propTypes = {
    href: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string
};
module.exports["PeopleLink"] = $6a5a2957e3d32f84$export$43aa0d4f5c176033;

});

parcelRegister("fs6LW", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $esRft = parcelRequire("esRft");


var $jyPfN = parcelRequire("jyPfN");


var $9wGTI = parcelRequire("9wGTI");


var $a6t12 = parcelRequire("a6t12");

const $98dff64af54e38f8$var$avatarWrapperStyles = {
    base: (0, $ecnYn.xcss)({
        display: 'inline-flex',
        backgroundColor: 'color.background.neutral.subtle',
        borderWidth: '0',
        padding: 'space.0',
        borderRadius: 'radius.full',
        outlineOffset: 'space.0',
        ':focus-within': {
            outlineStyle: 'solid',
            outlineWidth: 'border.width.focused',
            outlineColor: 'color.border.focused'
        }
    }),
    cursor: (0, $ecnYn.xcss)({
        cursor: 'pointer'
    })
};
const $98dff64af54e38f8$var$i18n = (0, $cgtv4.defineMessages)({
    label: {
        id: "profile.avatar.image",
        defaultMessage: "profile image of a user"
    },
    ariaLabel: {
        id: "profile.avatar.ariaLabel",
        defaultMessage: "More information about {name}"
    }
});
const $98dff64af54e38f8$export$3778be82376b06d7 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(42);
    const { userId: userId, canViewProfile: t1, isAnonymous: t2, size: t3, src: src, onClick: onClick, trigger: trigger, name: name, stackIndex: stackIndex, testId: testId, position: position, borderColor: borderColor, offset: offset } = t0;
    const canViewProfile = t1 === undefined ? true : t1;
    const isAnonymous = t2 === undefined ? false : t2;
    const size = t3 === undefined ? "medium" : t3;
    const intl = (0, $8C5kA.default)();
    const avatarSrc = isAnonymous || !canViewProfile || !src ? undefined : src;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const avatarRef = (0, $42omo.useRef)(null);
    const [isVisible, setIsVisible] = (0, $42omo.useState)(false);
    const [shouldReturnFocus, setShouldReturnFocus] = (0, $42omo.useState)(false);
    const [wasKeyboardAction, setWasKeyboardAction] = (0, $42omo.useState)(false);
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (isVisible_0)=>{
            setIsVisible(isVisible_0);
        };
        $[0] = t4;
    } else t4 = $[0];
    const handleVisibilityChange = t4;
    let t5;
    let t6;
    if ($[1] !== isVisible || $[2] !== shouldReturnFocus) {
        t5 = ()=>{
            if (shouldReturnFocus && !isVisible && avatarRef.current) {
                avatarRef.current.focus();
                setShouldReturnFocus(false);
            }
        };
        t6 = [
            isVisible,
            shouldReturnFocus
        ];
        $[1] = isVisible;
        $[2] = shouldReturnFocus;
        $[3] = t5;
        $[4] = t6;
    } else {
        t5 = $[3];
        t6 = $[4];
    }
    (0, $42omo.useEffect)(t5, t6);
    let t7;
    if ($[5] !== isVisible || $[6] !== wasKeyboardAction) {
        t7 = (e)=>{
            e.stopPropagation();
            if (e.key === "Enter") {
                setWasKeyboardAction(true);
                setIsVisible($98dff64af54e38f8$var$_temp);
                setShouldReturnFocus(true);
            } else if (e.key === "Escape" && isVisible && wasKeyboardAction) {
                setIsVisible(false);
                setWasKeyboardAction(false);
                setShouldReturnFocus(true);
            }
        };
        $[5] = isVisible;
        $[6] = wasKeyboardAction;
        $[7] = t7;
    } else t7 = $[7];
    const handleKeyDown = t7;
    const t8 = (0, $9wGTI.fg)("a11y_whiteboards_changes") ? "" : name || "";
    let t9;
    if ($[8] !== intl) {
        t9 = (0, $9wGTI.fg)("a11y_whiteboards_changes") ? {} : {
            label: intl.formatMessage($98dff64af54e38f8$var$i18n.label)
        };
        $[8] = intl;
        $[9] = t9;
    } else t9 = $[9];
    let t10;
    if ($[10] !== avatarSrc || $[11] !== borderColor || $[12] !== onClick || $[13] !== size || $[14] !== stackIndex || $[15] !== t8 || $[16] !== t9 || $[17] !== testId) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
            src: avatarSrc,
            size: size,
            target: "_blank",
            name: t8,
            ...t9,
            stackIndex: stackIndex,
            testId: testId,
            borderColor: borderColor,
            onClick: onClick
        });
        $[10] = avatarSrc;
        $[11] = borderColor;
        $[12] = onClick;
        $[13] = size;
        $[14] = stackIndex;
        $[15] = t8;
        $[16] = t9;
        $[17] = testId;
        $[18] = t10;
    } else t10 = $[18];
    const Icon = t10;
    let t11;
    if ($[19] !== intl || $[20] !== isVisible || $[21] !== name) {
        t11 = ()=>{
            if ((0, $9wGTI.fg)("a11y_whiteboards_changes")) return {};
            return {
                "aria-haspopup": "true",
                "aria-expanded": isVisible,
                "aria-label": intl.formatMessage($98dff64af54e38f8$var$i18n.ariaLabel, {
                    name: name || ""
                }),
                role: "button",
                tabIndex: 0
            };
        };
        $[19] = intl;
        $[20] = isVisible;
        $[21] = name;
        $[22] = t11;
    } else t11 = $[22];
    const getAriaProps = t11;
    const t12 = name || "";
    let t13;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = (0, $9wGTI.fg)("a11y_whiteboards_changes");
        $[23] = t13;
    } else t13 = $[23];
    const t14 = canViewProfile && hasViewUserProfilePermission && $98dff64af54e38f8$var$avatarWrapperStyles.cursor;
    let t15;
    if ($[24] !== t14) {
        t15 = [
            $98dff64af54e38f8$var$avatarWrapperStyles.base,
            t14
        ];
        $[24] = t14;
        $[25] = t15;
    } else t15 = $[25];
    let t16;
    if ($[26] !== getAriaProps) {
        t16 = getAriaProps();
        $[26] = getAriaProps;
        $[27] = t16;
    } else t16 = $[27];
    let t17;
    if ($[28] !== Icon || $[29] !== handleKeyDown || $[30] !== t15 || $[31] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: t15,
            testId: "avatarWrapperTestId",
            ref: avatarRef,
            onKeyDown: handleKeyDown,
            ...t16
        }, Icon);
        $[28] = Icon;
        $[29] = handleKeyDown;
        $[30] = t15;
        $[31] = t16;
        $[32] = t17;
    } else t17 = $[32];
    let t18;
    if ($[33] !== canViewProfile || $[34] !== isAnonymous || $[35] !== offset || $[36] !== position || $[37] !== t12 || $[38] !== t17 || $[39] !== trigger || $[40] !== userId) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
            userId: userId,
            canViewProfile: canViewProfile,
            isAnonymous: isAnonymous,
            trigger: trigger,
            fullName: t12,
            disabledAriaAttributes: t13,
            onVisibilityChange: handleVisibilityChange,
            position: position,
            offset: offset
        }, t17);
        $[33] = canViewProfile;
        $[34] = isAnonymous;
        $[35] = offset;
        $[36] = position;
        $[37] = t12;
        $[38] = t17;
        $[39] = trigger;
        $[40] = userId;
        $[41] = t18;
    } else t18 = $[41];
    return t18;
} : ({ userId: userId, canViewProfile: canViewProfile = true, isAnonymous: isAnonymous = false, size: size = 'medium', src: src, onClick: onClick, trigger: trigger, name: name, stackIndex: stackIndex, testId: testId, position: position, borderColor: borderColor, offset: offset })=>{
    const intl = (0, $8C5kA.default)();
    const avatarSrc = isAnonymous || !canViewProfile || !src ? undefined : src;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const avatarRef = (0, $42omo.useRef)(null);
    const [isVisible, setIsVisible] = (0, $42omo.useState)(false);
    const [shouldReturnFocus, setShouldReturnFocus] = (0, $42omo.useState)(false);
    const [wasKeyboardAction, setWasKeyboardAction] = (0, $42omo.useState)(false);
    const handleVisibilityChange = (isVisible_0)=>{
        setIsVisible(isVisible_0);
    };
    (0, $42omo.useEffect)(()=>{
        if (shouldReturnFocus && !isVisible && avatarRef.current) {
            avatarRef.current.focus();
            setShouldReturnFocus(false);
        }
    }, [
        isVisible,
        shouldReturnFocus
    ]);
    const handleKeyDown = (e)=>{
        e.stopPropagation();
        if (e.key === 'Enter') {
            setWasKeyboardAction(true);
            setIsVisible((prev)=>!prev);
            setShouldReturnFocus(true);
        } else if (e.key === 'Escape' && isVisible && wasKeyboardAction) {
            setIsVisible(false);
            setWasKeyboardAction(false);
            setShouldReturnFocus(true);
        }
    };
    const Icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        src: avatarSrc,
        size: size,
        target: "_blank",
        name: (0, $9wGTI.fg)('a11y_whiteboards_changes') ? '' : name || '',
        ...(0, $9wGTI.fg)('a11y_whiteboards_changes') ? {} : {
            label: intl.formatMessage($98dff64af54e38f8$var$i18n.label)
        },
        stackIndex: stackIndex,
        testId: testId,
        borderColor: borderColor,
        onClick: onClick
    });
    // Compute ARIA attributes based on feature flag
    const getAriaProps = ()=>{
        if ((0, $9wGTI.fg)('a11y_whiteboards_changes')) // When feature flag is enabled, don't add ARIA attributes to the div
        return {};
        // Legacy behavior: always add ARIA attributes when feature flag is off
        return {
            'aria-haspopup': 'true',
            'aria-expanded': isVisible,
            'aria-label': intl.formatMessage($98dff64af54e38f8$var$i18n.ariaLabel, {
                name: name || ''
            }),
            role: 'button',
            tabIndex: 0
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
        userId: userId,
        canViewProfile: canViewProfile,
        isAnonymous: isAnonymous,
        trigger: trigger,
        fullName: name || '',
        disabledAriaAttributes: (0, $9wGTI.fg)('a11y_whiteboards_changes'),
        onVisibilityChange: handleVisibilityChange,
        position: position,
        offset: offset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $98dff64af54e38f8$var$avatarWrapperStyles.base,
            canViewProfile && hasViewUserProfilePermission && $98dff64af54e38f8$var$avatarWrapperStyles.cursor
        ],
        testId: "avatarWrapperTestId",
        ref: avatarRef,
        onKeyDown: handleKeyDown,
        ...getAriaProps()
    }, Icon));
};
function $98dff64af54e38f8$var$_temp(prev) {
    return !prev;
}
module.exports["ProfileAvatar"] = $98dff64af54e38f8$export$3778be82376b06d7;

});

parcelRegister("lsxnT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $i3jcY = parcelRequire("i3jcY");


var $cryCi = parcelRequire("cryCi");


var $3KdFR = parcelRequire("3KdFR");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $42omo.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    // Stubbed context monkey-patches the original context to prevent Choreographer components
    // from being rendered, to avoid random impact on performance and UI stability tests.
    // This is ONLY intended to use with E2E/playwright/Criterion tests loading Confluence
    // with `?stableUI=1` URL parameter.
    const stubbedContext = (0, $42omo.useMemo)(()=>({
            ...ctx,
            ...(0, $3KdFR.choreographerContextStub)
        }), [
        ctx
    ]);
    return (0, $i3jcY.isStableUIEnabledForTests)() ? stubbedContext : ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("i3jcY", function(module, exports) {

var $4VJDS = parcelRequire("4VJDS");


const $47902e6ccb9229f6$var$STABLE_UI_PARAM = 'stableUI=1';
const $47902e6ccb9229f6$export$c0b9078f666b1acf = ()=>{
    if ((0, $4VJDS.default).isKillSwitchOn('cc_e2e_stable_ui')) // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return window.location.search.includes($47902e6ccb9229f6$var$STABLE_UI_PARAM);
    return false;
};
module.exports["isStableUIEnabledForTests"] = $47902e6ccb9229f6$export$c0b9078f666b1acf;

});

parcelRegister("3KdFR", function(module, exports) {
const $d24b02c281555a47$var$ChoreographerComponentStub = ()=>{
    return null;
};
const $d24b02c281555a47$var$withChoreographerStub = ()=>{
    return ()=>null;
};
const $d24b02c281555a47$export$62522e606ba73c28 = {
    AutoDismissFlag: $d24b02c281555a47$var$ChoreographerComponentStub,
    Banner: $d24b02c281555a47$var$ChoreographerComponentStub,
    Flag: $d24b02c281555a47$var$ChoreographerComponentStub,
    InlineDialog: $d24b02c281555a47$var$ChoreographerComponentStub,
    Modal: $d24b02c281555a47$var$ChoreographerComponentStub,
    PopoverContent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popper: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popup: $d24b02c281555a47$var$ChoreographerComponentStub,
    Spotlight: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightCard: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedRender: $d24b02c281555a47$var$withChoreographerStub,
    withChoreographedToggle: $d24b02c281555a47$var$withChoreographerStub
};
module.exports["choreographerContextStub"] = $d24b02c281555a47$export$62522e606ba73c28;

});

parcelRegister("foQ4a", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $19052bf55936e796$export$e581bd1f88227e0a = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isExternalCollaborator: accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS
    };
};
module.exports["useIsExternalCollaborator"] = $19052bf55936e796$export$e581bd1f88227e0a;

});

parcelRegister("fd6g2", function(module, exports) {
// "confluence.fe.custom.XXX"
const $88f9a74d7687653d$export$3fe4a04f712fdf3b = 'mentions-query';
const $88f9a74d7687653d$export$18a3d3c084ff47d0 = 'profile-card-query';
const $88f9a74d7687653d$export$95463e4d15a0dca9 = 'legacy-extension-loading';
const $88f9a74d7687653d$export$5a66bfdc2ac06329 = 'fabric-publish-page';
const $88f9a74d7687653d$export$96dfe3e664538004 = 'time-to-app-idle';
const $88f9a74d7687653d$export$18a3e97ff841447b = 'share-notif-from-restrictions';
const $88f9a74d7687653d$export$d0eb1faf5fa0dbc7 = 'tc-events-fetch';
const $88f9a74d7687653d$export$ec119fee4dbc7f75 = 'tc-subcals-fetch';
const $88f9a74d7687653d$export$5e0f3443b5224f1d = 'ai-snippet-hover-card';
const $88f9a74d7687653d$export$693c7d831f137ed3 = 'tc-jira-projects-fetch';
module.exports["MENTIONS_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$3fe4a04f712fdf3b;
module.exports["PROFILE_CARD_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$18a3d3c084ff47d0;
module.exports["LEGACY_EXTENSION_LOADING_CUSTOM_KEY"] = $88f9a74d7687653d$export$95463e4d15a0dca9;
module.exports["FABRIC_PUBLISH_PAGE_KEY"] = $88f9a74d7687653d$export$5a66bfdc2ac06329;
module.exports["TIME_TO_APP_IDLE_KEY"] = $88f9a74d7687653d$export$96dfe3e664538004;
module.exports["TEAM_CALENDARS_EVENT_FETCH_KEY"] = $88f9a74d7687653d$export$d0eb1faf5fa0dbc7;
module.exports["TEAM_CALENDARS_SUBCALS_FETCH_KEY"] = $88f9a74d7687653d$export$ec119fee4dbc7f75;
module.exports["TEAM_CALENDARS_JIRA_PROJECTS_FETCH_KEY"] = $88f9a74d7687653d$export$693c7d831f137ed3;

});


//# sourceMappingURL=RequestAccessPopup.1086a7bc.js.map
